import React, { Component } from 'react';
import { Button, Toast } from 'antd-mobile';
import store from '@/store/index';
import { ApiLoanProcessing } from '@/api/index';
import {
  $t,
  sensorsMonitor,
  AppList,
  getArray2Name,
  changeIco,
  getProxyConfig,
  setAliasApp,
} from '@/utils/utils';
import BannerRef from './banner';
import '@/assets/css/LoanProcessing.scss';

const ProxyCount = 20; // 默认请求3次 超过三次直接返回app首页
const ProxyTime = 3000; // 默认每一次轮询间隔3s
const SaSdk = sensorsMonitor();

class LoanProcessing extends Component {
  constructor(props) {
    super(props);
    // 当前app为请求url根目录
    const localApp = setAliasApp(props.match.params.app || 'ipeso');

    let app = getArray2Name(AppList, localApp);
    if (!app) {
      app = AppList[0]; // 默认走印度
    }

    // 默认设置墨西哥语
    store.dispatch({ type: 'set-i18n', data: app.i18n || 'es_MX' })

    document.title = $t('approvalTitle');
    this.state = {
      localApp,
      appRules: app,
      status: '1001', // 1001-等待 1004-信审失败 1002-信审成功
      showBanner: false,
      appData: null,
      localProxyNo: 0, // 第0次请求
    }
  }
  
  getResultCode(code) {
    const ResultMap = {
      '-2': '1004', // 多次放款失败
      '-1': '1004', // 信审失败
      '0': '1001', // 新建申请
      '1001': '1001', // 信审中
      '1002': '1002', // 信审通过
      '1004': '1004', // 信审异常
    }

    if (code >= 2000) {
      return '1002';
    }
    return ResultMap[code] || '1001';
  }
  // 获取风控状态
  getStatusData() {
    this.setState({ localProxyNo: this.state.localProxyNo + 1 })
    const { localApp } = this.state;
    const app = localApp === '_9jacash' ? '9jacash': localApp
    ApiLoanProcessing({
      ...getProxyConfig(app),
      headers: this.state.appData,
      notify: localApp !== 'parcecredit',
    }).then(res => {
      this.setState({ status: this.getResultCode(res.riskManageResult), })

      const { status, localProxyNo } = this.state
      if (status === '1001') {
        if (localProxyNo > ProxyCount) {
          Toast.success($t('soonJumpHome'), 1);
          this.goHome();
        } else {
          setTimeout(() => {
            this.getStatusData();
          }, ProxyTime)
        }
      }
    }).catch(err => {
      // 返回结果有误仅请求一次
      this.setState({ status: '1001' })  // 更改默认风控结果
    })
  }
  // 获取app的请求头
  getAppData() {
    const { localApp } = this.state
    const showBanner = ['kashway', 'ipesa', 'ucredit', 'ipeso', 'xfectivo', 'creavicash', 'creditmoja', 'mangucash', 'isente'].includes(localApp) // 底部显示bannner
    if (window.android) {
      const json = window.android.getRequestHeaders();

      const data = json ? JSON.parse(json) : null;
      this.setState({
        appData: Object.assign({}, this.state.appData, {
          ...data,
        }),
        showBanner,
      })
    } else {
      const data = {
        App_id: 'cash.pesa.loan.kenya',
        distinctId: 'C039197c7f20e0000',
        Authorization: 'Bearer 1C87CE57791B4C1F3F50A7386670E164D31E6A6B392A1BD3D21104B0112769E4',
        Mid: 'C039197c7f20e0000',
        App_version: '1.2.0',
        'Accept-Language': 'en',
      }

      this.setState({
        appData: Object.assign({}, this.state.appData, data),
        showBanner,
      })
    }
  }

  // 默认拿成功
  getSuccessData (title = false) {
    const { localApp } = this.state;
    // title
    if (title) {
      if (localApp === 'isolez' || localApp === 'caja' || localApp === 'parcecredit' || localApp === 'credifio-co') return $t('isolezApplySuccessTitle');
      if (localApp === 'tifi') return $t('tifiApplySuccessTitle');
      if (localApp === 'champloan') return $t('tifiApplySuccessTitle');

      return $t('approvalSuccess');
    }

    if (localApp === 'isolez' || localApp === 'caja') return $t('isolezApplySuccessNote');

    if (localApp === 'parcecredit' || localApp === 'credifio-co') return $t('parceCreditApplySuccessNote');

    if (localApp === 'tifi') return $t('tifiApplySuccessNote');

    return $t('approvalSuccessNote');
  }

  getLocalStatus() {
    const { localApp } = this.state;

    // const i18n = store.getState().setting.LocalesI18n; // 当前多语言
    const rootUrl = window.$localCdnLink +'/app/'+ localApp +'/loan-processing/';
    const StatusMap = {
      '1001': {
        title: this.getWaitingTitle(),
        note: this.getWaitingNote(),
        icon: `${ rootUrl }apply-waiting.svg`,
      },
      '1002': {
        title: this.getSuccessData(true),
        note: this.getSuccessData(),
        icon: `${ rootUrl }apply-success.svg`,
      },
      '1004': {
        title: this.getFailedTitle(),
        subTitle: $t('approvalFailedSubTitle'),
        note: this.getFailedNote(),
        icon: `${ rootUrl }apply-failed.svg`,
      },
    }
    return StatusMap[this.state.status] || StatusMap['1001'];
  }

  getWaitingTitle () {
    const { localApp } = this.state;
    const waitMap = {
      'tifi-ke': $t('tifiApprovalWaiting'),
      'parcecredit': 'Solictud en proceso',
      'credifio-co': 'Solictud en proceso',
      'default': $t('approvalWaiting')
    }
    return waitMap[localApp] || waitMap['default']
  }
  getWaitingNote () {
    const { localApp } = this.state;
    const waitNoteMap = {
      'tifi-ke': $t('tifiApprovalWaitingNote'),
      'credifio-co': 'Ya recibimos tu solicitud. Estamos analizando tu perfil crediticio y en momento te haremos saber el resultado a través de la APP y SMS.',
      'parcecredit': 'Ya recibimos tu solicitud. Estamos analizando tu perfil crediticio y en momento te haremos saber el resultado a través de la APP y SMS.',
      'default': $t('approvalWaitingNote')
    }
    return waitNoteMap[localApp] || waitNoteMap['default']
  }

  getFailedTitle () {
    const { localApp } = this.state;
    if (localApp === 'tifi-ke') {
      return $t('tifiApprovalFailed')
    } else if (localApp === 'tifislice') {
      return $t('tifisliceApprovalFailed')
    } else {
      return $t('approvalFailed')
    }
  }
  getFailedNote () {
    const { localApp, appRules } = this.state;
    if (localApp === 'tifi-ke') {
      return $t('tifiApprovalFailedNote')
    }

    const i18n = store.getState().setting.LocalesI18n; // 当前多语言
    return i18n === 'en_US' ? $t('approvalFailedNote') :
          $t('approvalFailedNote1') + appRules.appName + $t('approvalFailedNote2')
  }

  // 神策打点初始化
  saInit() {
    SaSdk.registerPage({
      appName: 'ipeso',
    })

    SaSdk.track('h5_loan_application');
  }

  // 点击确认
  handleOk() {
    SaSdk.track('h5_loan_application_ok');
    this.goHome();
  }
  // 跳回app首页
  goHome() {
    if (window.android) {
      // Toast.success(`即将跳回首页`, 10);
      window.android.jumpToHome();
    } else {
      Toast.fail(`获取android方法失败`, 10);
    }
  }

  componentDidMount() {
    const { localApp } = this.state;
    // console.log(localApp)
    const approvalTitleMap = {
      'parcecredit': 'Solicitud de préstamo',
      'credifio-co': 'Solicitud de préstamo',
      'default': $t('approvalTitle')
    }
    document.title = approvalTitleMap[localApp] || approvalTitleMap['default'];
    changeIco(this.state.localApp);
    this.saInit();
    this.getAppData();
    setTimeout(() => {
      this.getStatusData();
    }, 80)
  }

  render() {
    const { showBanner, localApp, status, appData, appRules } = this.state;

    const localStatusObj = this.getLocalStatus();
    const mainClass = 'loan-processing ' + localApp;
    let subTitle = '';
    if (localStatusObj.subTitle) {
      subTitle = <h4>{ localStatusObj.subTitle }</h4>
    }
    const rootUrl = window.$localCdnLink +'/app/'+ localApp +'/loan-processing/';
    
    const okBtn = ['isolez', 'credifio'].includes(localApp) ? <img
      src={ rootUrl + 'next.webp' }
      alt='MIB'
    />
    : ['parcecredit', 'credifio-co'].includes(localApp) ? $t('confirmar'): $t('ok')

    const BtnSvg = ['caja','isolez'].includes(localApp) ? <div
      className='radius-btn'
    /> : null
    
    let approvalWarning = '';
    // 审核通过、审核中添加防欺诈文案提示
    // 仅有墨西哥才有OXXO
    // 审核通过、审核中添加防欺诈文案提示 墨西哥才有警告
    if (appRules.i18n === 'es_MX') {
      if ((localApp !== 'isolez' && localApp !== 'caja' && localApp !== 'tifi' && localApp !== 'champloan' && localApp !== 'parcecredit' && localApp !== 'credifio-co') && (status === '1002' || status === '1001')) {
        approvalWarning = <div className="label"
                dangerouslySetInnerHTML={{ __html: $t('approvalWarning') }}></div>
      }
    }

    return <div className={ mainClass }>
      {/* <div className="title">Application Processing</div> */}
      <div className="body">
        <div className="loading">
          {/* <MEmbed
            className="icon"
            type="image/svg+xml"
            src={ localStatusObj.icon }
          /> */}
          <embed className="icon" type="image/svg+xml" src={ localStatusObj.icon } />
        </div>
        <div className="noted">
          <h3>{ localStatusObj.title }</h3>
          { subTitle }
          <div 
            className="label"
            dangerouslySetInnerHTML={{ __html: localStatusObj.note }}
          >
          </div>

          { approvalWarning }
        </div>
      </div>
      <div className="footer">
        <Button type="ghost" size="large" onClick={() => this.handleOk() }>
          {
            (BtnSvg && BtnSvg) || okBtn
          }
        </Button>
      </div>

      { showBanner ? <BannerRef app={localApp} header={appData} /> : '' }
    </div>
  }
}

export default LoanProcessing;